import React from 'react';
import { Helmet } from 'react-helmet';
import BlogList from './BlogList';

const Blog = () => (
  <div style={{ fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif" }}>
    <Helmet>
      <title>Blog | SpireNest - NetSuite Insights & Resources</title>
      <link rel="canonical" href="https://spirenest.co/blog" />
      <meta
        name="description"
        content="Explore the SpireNest blog for NetSuite insights, best practices, and industry updates on ERP, CRM, and business solutions."
      />
    </Helmet>

    <div
      style={{
        background: 'linear-gradient(135deg, #0a1628 0%, #0e2044 50%, #0a1628 100%)',
        padding: '5rem 1.5rem 4rem',
        textAlign: 'center',
      }}
    >
      <h1 style={{ color: 'white', fontWeight: 800, fontSize: '2.4rem' }}>Our Blog</h1>
      <p style={{ color: '#b8c4d9', fontSize: '1.05rem', maxWidth: '560px', margin: '.75rem auto 0' }}>
        Insights, tips, and the latest updates from the world of NetSuite and business management.
      </p>
    </div>

    <BlogList />
  </div>
);

export default Blog;
